// extracted by mini-css-extract-plugin
export var dateLabel = "_3u-0";
export var dateLabelError = "_3u-1";
export var fullWidth = "_3u-2";
export var smaller = "_3u-3";